import { translateArray } from '../../translate/I18n';

/**
 * @typedef {{category: string, questions: QuestionsAnswers[]}} QuestionsByCategory
 * @typedef {{a :string, q: string}} QuestionsAnswers
 */

/**
 * @param {string} namespace
 * @param {TFunction} t
 * @return {QuestionsByCategory[]}
 */
export const getQuestionsByCategoryFromNamespace = (t, namespace) =>
  translateArray(t, namespace).map(({ questions, category }) => {
    return {
      questions,
      category
    };
  });
